"use strict";

import links from '../components/links';

export default {
    init: () => {
        let $elem = document.querySelector('.vantagens'),
            link = '';

        link = `vantagens.html?${links.getParams()}`+`${links.getInternParams()}`;

        // $elem.setAttribute('href', link);
    }
}